import { Avatar, Checkbox, ConfigProvider } from 'antd';
import colorTheme from 'constants/color';
import { AptDetailV3DataItem } from 'features/appointment/services/types/appointment';
import { CheckOutlined } from '@ant-design/icons';
import React from 'react';
import styled from 'styled-components';
import { formatTimeRange } from './helpers';

type Props = {
  item: AptDetailV3DataItem;
  checked: boolean;
  onToggle: () => void;
};

const AppointmentSelectCard: React.FC<Props> = ({ item, checked, onToggle }) => {
  return (
    <CardStyled onClick={onToggle} type="button">
      <div className="menu-item">
        <div className="avatar-group">
          <Avatar className="staff-avatar" size={48} src={item.staffAvatar} style={{ color: '#fff', fontWeight: '600', fontSize: 24 }}>
            {item.staffName?.[0] || 'A'}
          </Avatar>
          <span className="staff-badge">
            <CheckOutlined />
          </span>
        </div>
        <div className="texts">
          <div className="head-row">
            <span className="staff-name">{item.staffName}</span>
            <span className="time-range">{formatTimeRange(item.startTime, item.endTime)}</span>
          </div>
          <p className="service-name">{item.serviceName}</p>
        </div>
      </div>
      <ConfigProvider
        theme={{ components: { Checkbox: { colorPrimary: colorTheme.v2_secondary_3, colorPrimaryHover: colorTheme.v2_secondary_3, borderRadiusSM: 3, controlInteractiveSize: 32 } } }}
      >
        <Checkbox className="select-box" checked={checked} />
      </ConfigProvider>
    </CardStyled>
  );
};

export default AppointmentSelectCard;

const CardStyled = styled.button`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  text-align: left;
  background: ${colorTheme.v2_neutral_1};
  border: 1px solid ${colorTheme.v2_neutral_4};
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0px 4px 8px -4px rgba(0, 0, 0, 0.15);
  cursor: pointer;

  .menu-item {
    display: flex;
    flex: 1 0 0;
    min-width: 0;
    gap: 16px;
    align-items: flex-start;
  }

  .avatar-group {
    position: relative;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .staff-avatar {
    width: 48px;
    height: 48px;
  }
  .staff-badge {
    position: absolute;
    bottom: -8px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 8px;
    background: ${colorTheme.v2_primary_bg_6};
    color: ${colorTheme.v2_neutral_1};
    font-size: 14px;
  }

  .texts {
    display: flex;
    flex: 1 0 0;
    min-width: 0;
    flex-direction: column;
  }
  .head-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
  }
  .staff-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-transform: uppercase;
    color: ${colorTheme.v2_text_5};
    font-family: Poppins;
    font-size: 20px;
    font-weight: 600;
  }
  .time-range {
    flex-shrink: 0;
    color: ${colorTheme.v2_secondary_3};
    font-family: Poppins;
    font-size: 18px;
    font-weight: 600;
    line-height: 30px;
  }
  .service-name {
    padding-top: 4px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: ${colorTheme.v2_text_5};
    font-family: Poppins;
    font-size: 16px;
    font-weight: 400;
  }

  .select-box {
    flex-shrink: 0;
    pointer-events: none;
  }
`;
